import React, { useEffect, useState } from "react";
import API from "../../../util/API";
import { Badge, Card } from "./mailUI";

const EmailLogs = () => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const loadHistory = async () => {
    setLoading(true);
    try {
      const res = await API.get("/mail/history?limit=50&page=1");
      setItems(res.data?.data?.items || []);
      setTotal(res.data?.data?.total || 0);
    } catch {
      setItems([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadHistory();
  }, []);

  return (
    <Card
      title="Email Logs"
      subtitle="Latest delivery attempts from SMTP and template sends."
      right={<Badge tone="info">{total} records</Badge>}
    >
      {loading ? (
        <p className="text-sm text-slate-500">Loading logs...</p>
      ) : items.length === 0 ? (
        <p className="text-sm text-slate-500">No email logs found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead className="text-xs uppercase text-slate-500">
              <tr>
                <th className="px-3 py-2">Recipient</th>
                <th className="px-3 py-2">Subject</th>
                <th className="px-3 py-2">Status</th>
                <th className="px-3 py-2">Sent At</th>
                <th className="px-3 py-2">Error</th>
              </tr>
            </thead>
            <tbody>
              {items.map((row) => (
                <tr key={row._id} className="border-t border-slate-200">
                  <td className="px-3 py-2 text-slate-700">{row.to}</td>
                  <td className="px-3 py-2 text-slate-700">{row.subject}</td>
                  <td className="px-3 py-2">
                    <Badge tone={row.status === "sent" ? "success" : "danger"}>
                      {row.status}
                    </Badge>
                  </td>
                  <td className="px-3 py-2 text-slate-500">
                    {row.sentAt ? new Date(row.sentAt).toLocaleString() : "—"}
                  </td>
                  <td className="px-3 py-2 text-slate-500">
                    {row.error || "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
};

export default EmailLogs;
